import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {Moment} from 'moment-timezone';
import {MedicalRecordPainModel} from '../../../pain/api/model/medicalRecordPain.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {MedicalRecordProblemModel} from '../../../problem/api/model/medicalRecordProblem.model';
import {MedicalRecordVisitReasonLabelModel} from './medicalRecordVisitReasonLabel.model';
import {ConsultationSummaryModel} from '../../../../consultation/consultation/api/model/consultationSummary.model';

export class MedicalRecordVisitReasonModel implements SummaryModel {
    id: number;
    partner: PartnerSummaryModel;
    date: Moment;
    comment: string;
    pains: MedicalRecordPainModel[] = [];
    problems: MedicalRecordProblemModel[] = [];
    labels: MedicalRecordVisitReasonLabelModel[] = [];
    consultation: ConsultationSummaryModel;
    permissions: PermissionsModel;
}
